import {
  getCachedAttachmentBlob,
  setCachedAttachmentBlob,
} from "@/lib/cache/attachmentBlobCache";
import { idbGetAttachment, idbPutAttachment } from "@/lib/cache/attachmentIndexedDB";
import { fetchMailAttachmentBlob as fetchMailAttachmentBlobNetwork } from "@/lib/api/imap";

export type AttachmentBlobFetchParams = {
  uid: number;
  part: string;
  accountId?: number;
  folder?: string;
  filename?: string;
};

function canUseLocalCache(params: AttachmentBlobFetchParams): params is AttachmentBlobFetchParams & {
  accountId: number;
  folder: string;
} {
  return (params.accountId ?? 0) > 0 && Boolean(params.folder);
}

/**
 * PJ preview : RAM → IndexedDB (navigateur) → HTTP (DD02 serveur, partagé tous terminaux).
 */
export async function fetchMailAttachmentBlobCached(
  params: AttachmentBlobFetchParams
): Promise<Blob> {
  if (canUseLocalCache(params)) {
    const cacheParams = {
      accountId: params.accountId,
      folder: params.folder,
      uid: params.uid,
      part: params.part,
    };

    const memHit = getCachedAttachmentBlob(cacheParams);
    if (memHit) return memHit;

    try {
      const idbHit = await idbGetAttachment(cacheParams);
      if (idbHit) {
        setCachedAttachmentBlob(cacheParams, idbHit);
        return idbHit;
      }
    } catch {
      /* IndexedDB indisponible — réseau */
    }
  }

  const blob = await fetchMailAttachmentBlobNetwork(params);

  if (canUseLocalCache(params)) {
    const cacheParams = {
      accountId: params.accountId,
      folder: params.folder,
      uid: params.uid,
      part: params.part,
    };
    setCachedAttachmentBlob(cacheParams, blob);
    void idbPutAttachment(cacheParams, blob).catch(() => {
      /* quota / mode privé */
    });
  }

  return blob;
}
